<template>
  <b-container fluid id="form-container" ref="formContainer">
    <b-row>
      <b-col>
        <h2>Request Application Access or Role</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
      </b-col>
    </b-row>

    <b-row>
        <b-col>
            <h3>Instructions</h3>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <p>
                The HRM Request System is where requests for HRM services, including vacancy filling, can be submitted, approved, processed, and tracked.
                Specific user-role assignment must be granted before you may use the system. Roles are determined based on the different sets of tasks a
                person performs within the HRM Request System.
            </p>
            <p>
                On this page you may request access to interact with this system for yourself or for another MDH staff member. If you are requesting on behalf
                of someone else, indicate their name in the drop-down for Person Needing Role. Note: the primary system user role is that of Requester.
            </p>
            <p>
                You will be notified by email when the access request has been granted (or denied).
            </p>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseEmployeeSelector v-model="request.requestedUser"
                                  label="Person Needing Role"
                                  :v="$v.request.requestedUser"
                                  slug="requestedUser"
                                  tip=""
                                  :showPcn="false"/>
        </b-col>
    </b-row>

    <b-row>
        <b-col>
            <BaseSelector v-model="request.requestedRole"
                          :v="$v.request.requestedRole"
                          label="Role Requested"
                          :options = reqRoles
            />
        </b-col>
    </b-row>
    
    <b-row>
      <b-col>
        <hr/>
         <b-button type="button" variant="primary" @click="onSubmit">Submit</b-button>
      </b-col>
    </b-row>

    <b-row>
        <b-col>
            <h3>About the user roles</h3>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            These roles allow users to complete request related tasks specific to their work areas. If in doubt, ask for the Requester role.
            <ul>
                <li>
                    <span class="font-weight-bold">Requester </span>– main role used to create a request and view its progress
                </li>
                <li>
                    <span class="font-weight-bold">FFM Reviewer </span>– role used by assigned Financial Management staff
                </li>
                <li>
                    <span class="font-weight-bold">Payroll and Transactions </span>– roles used by HRM Operations staff
                </li>
                <li>
                    <span class="font-weight-bold">HRM Specialist </span>– main role used by HRM Staffing
                </li>
                <li>
                    <span class="font-weight-bold">HRM Lead </span>– additional role used by HRM Staffing Consultants
                </li>
                <li>
                  <span class="font-weight-bold">Approver Audit Review </span>– application settings related to the Audit process
                </li>
                <li>
                  <span class="font-weight-bold">Approver Post Draft Review </span>– application settings related to the Post Draft Review process
                </li>
                <li>
                  <span class="font-weight-bold">Approver Salary Review </span>– application settings related to the Salary Review process
                </li>
            </ul>
        </b-col>
    </b-row>

  </b-container>
</template>

<script>
import axios from "axios"
import { required } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'

export default {
  data: () => ({
    request: {
        requestedRole: null,
        requestedUser: null,
        submitter: null
    }
  }),
  created() {
      this.loadEmployee()
  },
  mixins: [
      commonOptions,
  ],
  validations() {
    return {
        request: {
            requestedRole: {required},
            requestedUser: {required},
            submitter: {required}
        }
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          this.$nextTick(() => {
              document.getElementById('form-container').scrollIntoView()
          })
          return
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/roles/access`, this.request)
          .then(response => { 
            this.$bvToast.toast('Request Submitted', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            })
           })
    },
      loadEmployee() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles/currentEmployee`)
              .then(response => {
                  this.request.submitter = response.data
                  this.request.requestedUser = response.data
              })
      }
  }
}
</script>

<style>

</style>
